import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidAngleDownIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10Zm3.5-12.8c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-4.2 4.2c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-4.2-4.2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3.5 3.5 3.5-3.5Z" clipRule="evenodd"/>
  </SvgIcon>
}

export default SolidAngleDownIcon
